// extracted by mini-css-extract-plugin
export default {"table":"AgilysysPOSList_table__3UvNn","badge":"AgilysysPOSList_badge__11hL+","btn":"AgilysysPOSList_btn__a4OBA"};